import React from 'react';
import { Typography } from '@attentive-platform/stem-ui';
import { BILLING_FREQUENCY, BILLING_FREQUENCY_ENUM } from '../../Constants/Constants';

const ContractTermsSection = ({
  contractInfo,
  setContractInfo,
  handleDataChange,
  setDates,
  readOnly = false,
  totalUsers = '',
  onTotalUsersChange
}) => (
  <div className='border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50'>
    <div className='flex items-center gap-1 mb-3 pb-2 border-b border-gray-100'>
      <Typography variant='subtitle1-medium' color='var(--color-neutral-80)'>
        Shared contract terms
      </Typography>
      {readOnly && (
        <span className='ml-2 text-xs font-medium px-2 py-0.5 rounded bg-blue-100 text-blue-700'>
          Synced — read-only
        </span>
      )}
    </div>
    <div className='input-group mb-3'>
      <Typography className='input-group-text w-1/2'>Contract Start Date</Typography>
      <input
        type='date'
        value={contractInfo.start_date ?? ''}
        onChange={e => {
          if (!readOnly) setDates(e.target.value);
        }}
        className='form-control '
        placeholder=''
        required
        disabled={readOnly}
      />
    </div>
    <div className='input-group mb-3 '>
      <Typography className='input-group-text w-1/2'>Contract End Date</Typography>
      <input
        type='date'
        value={contractInfo.end_date ?? ''}
        onChange={e => {
          if (!readOnly) setContractInfo(prev => ({ ...prev, end_date: e.target.value }));
        }}
        className='form-control'
        required
        disabled={readOnly}
      />
    </div>

    <div className='input-group mb-3 '>
      <Typography className='input-group-text w-1/2'>Platform Access End Date</Typography>
      <input
        type='date'
        value={contractInfo.platformAccessDate ?? ''}
        onChange={e => {
          if (!readOnly) setContractInfo(prev => ({ ...prev, platformAccessDate: e.target.value }));
        }}
        className='form-control'
        disabled={readOnly}
      />
    </div>

    <div className='input-group mb-3 '>
      <Typography className='input-group-text w-1/2'>Billing Frequency</Typography>
      <div className='dropdown w-1/2'>
        <button
          className='btn border text-dark dropdown-toggle w-full'
          type='button'
          data-toggle='dropdown'
          data-bs-toggle='dropdown'
          disabled={readOnly}>
          {BILLING_FREQUENCY[contractInfo?.billing_frequency]}
        </button>
        <div className='dropdown-menu w-full'>
          <span
            className='dropdown-item '
            onClick={() => !readOnly && handleDataChange(BILLING_FREQUENCY_ENUM.QUARTERLY, 'billing_frequency')}>
            {BILLING_FREQUENCY[BILLING_FREQUENCY_ENUM.QUARTERLY]}
          </span>
          <span
            className='dropdown-item'
            onClick={() => !readOnly && handleDataChange(BILLING_FREQUENCY_ENUM.MONTHLY, 'billing_frequency')}>
            {BILLING_FREQUENCY[BILLING_FREQUENCY_ENUM.MONTHLY]}
          </span>
          <span
            className='dropdown-item'
            onClick={() => !readOnly && handleDataChange(BILLING_FREQUENCY_ENUM.HALF_YEARLY, 'billing_frequency')}>
            {BILLING_FREQUENCY[BILLING_FREQUENCY_ENUM.HALF_YEARLY]}
          </span>
          <span
            className='dropdown-item'
            onClick={() => !readOnly && handleDataChange(BILLING_FREQUENCY_ENUM.ANNUAL, 'billing_frequency')}>
            {BILLING_FREQUENCY[BILLING_FREQUENCY_ENUM.ANNUAL]}
          </span>
        </div>
      </div>
    </div>

    <div className='input-group mb-3 '>
      <Typography className='input-group-text w-1/2'>Total users</Typography>
      <input
        type='number'
        min={0}
        step={1}
        value={totalUsers ?? ''}
        onChange={e => {
          if (!readOnly) onTotalUsersChange?.(e.target.value);
        }}
        className='form-control'
        placeholder='Seats / user count'
        disabled={readOnly}
      />
    </div>
  </div>
);

export default ContractTermsSection;
